<template>
  <el-form-item style="background: #f5f5f5; padding: 5px; margin-bottom: 10px">
    <!-- <el-input
      v-model="localTemplateStr"
      placeholder="TEXT(your_text)"
      style="width: 300px"
    /> -->

    <label
      v-if="templateChanged"
      @click="handleRefreshTemplate"
      style="margin-left: 5px; min-width: 50px; color: red"
    >
      {{ header }}
      <el-icon>
        <Refresh />
      </el-icon>
    </label>
    <label v-else style="margin-left: 5px; min-width: 50px; color: green">
      {{ header }}
    </label>
    <el-button-group style="margin-left: 10px">
      <el-button @click="handleAddTextTemplateItem()"> 添加 TEXT </el-button>
      <el-button @click="handleAddNumTemplateItem()"> 添加 NUM </el-button>
    </el-button-group>

    <el-form-item
      v-for="(item, idx) in templateMap"
      :key="idx"
      style="display: inline-block; margin-left: 10px"
    >
      <el-icon style="margin-top: -15px" @click="handleRemoveTemplateItem(idx)">
        <Remove />
      </el-icon>
      <span v-if="item.type === 0" style="">
        TEXT(
        <el-input
          @change="handleDisableGenerate"
          v-model="item.val"
          placeholder="TEXT(your_text)"
          style="width: 100px; margin-left: 5px"
        />
        )
      </span>
      <span v-else-if="item.type === 1" style="">
        NUM(
        <el-input
          @change="handleDisableGenerate"
          v-model.number="item.val"
          placeholder="NUM(your_number)"
          style="width: 100px; margin-left: 5px"
          type="number"
        />
        )
      </span>
    </el-form-item>
  </el-form-item>
</template>
<script>
export default {
  name: "TemplateRow",
  props: {
    index: {
      type: Number,
      required: true,
    },
    header: {
      type: String,
      required: true,
    },
    templateStr: {
      type: String,
      required: true,
    },
  },
  mounted() {
    const regex = /(TEXT\(([\u4e00-\u9fa5a-zA-Z0-9 ]+)\))|(NUM\(([\d]+)\))/g;
    let match = [...this.localTemplateStr.matchAll(regex)];

    match.forEach((m) => {
      if (m[1]) {
        // TEXT matched
        console.log("TEXT", m[2]);
        this.templateMap.push({ type: 0, val: m[2] });
      } else if (m[3]) {
        // NUM matched
        console.log("NUM", m[4]);
        this.templateMap.push({ type: 1, val: parseInt(m[4]) });
      }
    });
  },
  data() {
    return {
      templateChanged: false,
      localTemplateStr: this.templateStr,
      templateMap: [], // { type: 0 for TEXT, 1 for NUM, val: string or number }
    };
  },
  methods: {
    handleAddTextTemplateItem() {
      this.handleDisableGenerate();

      if (this.templateMap.length >= 3) {
        this.$message.error("单个表头最多添加3个模板项");
        return;
      }
      this.templateMap.push({ type: 0, val: "your_text" });
    },
    handleAddNumTemplateItem() {
      this.handleDisableGenerate();

      if (this.templateMap.length >= 3) {
        this.$message.error("单个表头最多添加3个模板项");
        return;
      }
      this.templateMap.push({ type: 1, val: 100 });
    },
    handleRemoveTemplateItem(idx) {
      this.handleDisableGenerate();
      // Remove from template map
      this.templateMap.splice(idx, 1);
    },
    handleDisableGenerate() {
      if (this.templateChanged === false) {
        this.templateChanged = true;

        this.$emit("disable-generate");
      }
    },
    handleRefreshTemplate() {
      this.templateChanged = false;
      // Rebuild localTemplateStr from templateMap
      let parts = this.templateMap.map((item) => {
        if (item.type === 0) {
          return `TEXT(${item.val})`;
        } else if (item.type === 1) {
          return `NUM(${item.val})`;
        }
        return "";
      });
      this.localTemplateStr = parts.join("");
      console.log("handleRefreshTemplate", this.localTemplateStr, this.index);
      // Notify parent component
      this.$emit("new-template-str", { idx: this.index, val: this.localTemplateStr });
    },
  },
};
</script>
